import { isString } from "../core/helpers/string-util.js";
import Model from "./Model.js";
import polyglot from "../core/polyglot/polyglot.js";

/**
 * A translatedString represents text that has its own translation table.
 *
 * @param {string} spec.value - Untranslated string. The value is used if no
 * translation exists for the current Polyglot language.
 * @param {object} spec.translations - Translation table. Each key is a
 * language code, with the translation string as value.
 */
export default class TranslatedString extends Model {
	constructor({ value, translations = {} } = {}) {
		super(...arguments);

		this._value = value;
		this._translations = translations;
	}

	getValue() {
		return this._value;
	}

	toString() {
		return this.currentTranslation();
	}

	currentTranslation() {
		return this.translates(polyglot.getLanguage());
	}

	translates(language) {
		return this._translations[language] || this._value;
	}

	languages() {
		return Object.keys(this._translations);
	}

	appendToBrush(brush) {
		brush.render(this.currentTranslation());
	}

	localeCompare(anotherString, ...rest) {
		return this.toString().localeCompare(anotherString.toString(), ...rest);
	}

	toUpperCase() {
		return this.toString().toUpperCase();
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.value = this._value;
		properties.translations = this._translations;

		return properties;
	}

	static materialize(data) {
		// Handle raw strings as input for backward compatibility
		if (isString(data)) {
			return this.materialize({ value: data });
		}

		return super.materialize(...arguments);
	}
}
